/*  AnalyticsSidebar.jsx – mobile-hamburger  */
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu }     from 'lucide-react';          // icon
import './_analytics.css';

export default function AnalyticsSidebar() {
  /* --- local toggle --- */
  const [open, setOpen] = useState(false);

  const navItem = (to, label, icon) => (
    <NavLink
      to={to}
      /* on any navigation → close drawer */
      onClick={() => setOpen(false)}
      className={({ isActive }) => 'anav ' + (isActive ? 'active' : '')}
    >
      <span className="ani">{icon}</span>
      <span>{label}</span>
    </NavLink>
  );

  return (
    <>
      {/* hamburger (only shows on ≤768px via CSS) */}
      <button
        className="burger-btn"
        aria-label="menu"
        onClick={() => setOpen(o => !o)}
      >
        <Menu size={22}/>
      </button>

      {/* sidebar */}
      <aside className={'aside' + (open ? ' open' : '')}>
        <h3 className="aside-title">📊 Analytics</h3>
        {navItem('/analytics',                  'Insights',          '📈')}
        {navItem('/analytics/students',         'Students Tbl',      '🎓')}
        {navItem('/analytics/guests',           'Guests Tbl',        '🧑‍💼')}
        {navItem('/analytics/users',            'Users',             '👥')}
        {navItem('/analytics/hostels',          'Hostels',           '🏠')}
        {navItem('/analytics/warden-assignment','Warden Assignment', '🧑‍✈️')}
        {navItem('/analytics/settings',         'System Settings',   '⚙️')}
      </aside>

      {/* dim background when drawer open */}
      {open && <div className="shade" onClick={() => setOpen(false)}/>}
    </>
  );
}
